import type { VideoItemDto } from '@customTypes/types';
import { Image, Loader, Stack, Text } from '@mantine/core';
import { useState } from 'react';

import { resolveImagePath } from '@/shared/helper/resolveImagePath';
import { translate } from '@/shared/i18n/translate';

const VideoItem = ({ item }: { item: VideoItemDto }) => {
  const [showVideo, setShowVideo] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(true);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        minHeight: '190px',
        borderRadius: 20,
        overflow: 'hidden'
      }}
    >
      {isPreviewLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.5)'
          }}
        >
          <Loader />
        </div>
      )}
      <Image
        src={resolveImagePath(item.thumbnailPath)}
        style={{
          display: showVideo ? 'none' : isPreviewLoading ? 'hidden' : 'block',
          width: '100%',
          cursor: 'pointer'
        }}
        onLoad={() => setIsPreviewLoading(false)}
        onClick={() => {
          setShowVideo(true);
        }}
      />
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <video
          key={item.filePath}
          autoPlay
          controls
          disablePictureInPicture
          muted
          preload='auto'
          src={resolveImagePath(item.filePath)}
          style={{
            visibility: !showVideo ? 'hidden' : 'visible',
            height: !showVideo ? '0px' : '100%',
            width: '100%',
            borderRadius: '20px',
            maxWidth: '320px'
          }}
        />
      </div>
    </div>
  );
};

export const VideoList = ({ data }: { data: VideoItemDto[] }) => (
  <Stack gap={16}>
    {data.length ? (
      data.map((item) => <VideoItem key={item.id} item={item} />)
    ) : (
      <Text>{translate('commons.notFound.generic')}</Text>
    )}
  </Stack>
);
